import { AllowedGames } from "./AllowedGames";
import { State } from "./State";
export class Account {
    constructor(id, enabled, name, allowedGames) {
        this.id = id;
        this.enabled = new State(enabled);
        this.name = new State(name);
        this.allowedGames = new AllowedGames(allowedGames);
    }
    toJSON() {
        return {
            id: this.id,
            enabled: this.enabled.value,
            name: this.name.value,
            allowedGames: this.allowedGames,
        };
    }
}
